/**
 * HashIntegrityPanel — exibe o hash SHA-256 de integridade do relatório.
 *
 * Decisão P-4 (TL 06/Jun/2026): hash canônico SEMPRE presente; assinatura
 * digital ICP-Brasil DIFERIDA. Quando `signed=false` NÃO renderizar como
 * assinado — mostrar badge "assinatura ICP-Brasil pendente". Honesto vs o
 * mockup, que pinta um carimbo de assinatura que ainda não existe.
 */

export function HashIntegrityPanel({
  algorithm,
  hash,
  signed,
}: {
  algorithm: string;
  hash: string;
  signed: boolean;
}): JSX.Element {
  return (
    <div className="rep-hash">
      <span className="rep-hash__label">Hash de integridade · {algorithm.toUpperCase()}</span>
      <code className="rep-hash__val">{hash}</code>
      {signed ? (
        <span className="rep-hash__sig rep-hash__sig--signed">
          ✓ Assinado digitalmente · ICP-Brasil
        </span>
      ) : (
        <span className="rep-hash__sig rep-hash__sig--pending">
          ⏳ Assinatura digital ICP-Brasil pendente
        </span>
      )}
    </div>
  );
}
